import { Component, Input } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-success-animation',
  styleUrls: ['./success-animation.component.scss'],
  templateUrl: './success-animation.component.html',
})
export class SuccessAnimationComponent {
  @Input() public size = 140;
  @Input() public color;

  constructor() {}

}
